<div class="intercation-container">
    <div class="title">
        {{ "mimic.settings.toggle-intercation.title" | translate }}
    </div>
    <div>
        <fieldset class="fieldset" [class.selected]="showingActiveOptions">
            <legend class="legend" [class.selected]="showingActiveOptions">
                {{ "mimics.settings.toggle.active.state.legend" | translate }}
            </legend>
            <mat-select
                class="input"
                panelClass="active-status-panel"
                [(ngModel)]="activeStatus"
                (openedChange)="showingActiveOptions = !showingActiveOptions"
            >
                <mat-option
                    *ngFor="let status of statusOptions"
                    [value]="status"
                    class="active-status-option"
                >
                    {{ status }}
                </mat-option>
            </mat-select>
        </fieldset>
    </div>

    <div>
        <fieldset class="fieldset" [class.selected]="showingInactiveOptions">
            <legend class="legend" [class.selected]="showingInactiveOptions">
                {{ "mimics.settings.toggle.inactive.state.legend" | translate }}
            </legend>
            <mat-select
                class="input"
                panelClass="active-status-panel"
                [(ngModel)]="inactiveStatus"
                (openedChange)="
                    showingInactiveOptions = !showingInactiveOptions
                "
            >
                <mat-option
                    *ngFor="let status of statusOptions"
                    [value]="status"
                    class="active-status-option"
                >
                    {{ status }}
                </mat-option>
            </mat-select>
        </fieldset>
    </div>

    <div class="preview-state-container">
        <div>
            {{ "mimic.settings.toggle.preview-states.title" | translate }}
        </div>
        <div class="preview-state-toggle">
            <mat-slide-toggle
                class="toggle"
                [checked]="previewStates"
                (change)="updatePreviewStates($event)"
            >
            </mat-slide-toggle>
        </div>
    </div>
</div>
